export default "__VITE_ASSET__Da49wU1c__"